import { render, staticRenderFns } from "./RiskAssessmentTools.vue?vue&type=template&id=778f6b9a&"
import script from "./RiskAssessmentTools.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports